import clsx from 'clsx'
import * as React from 'react'

const alertVariants = {
  default: 'bg-card text-card-foreground border-border',
  destructive: 'border-destructive/50 text-destructive dark:border-destructive' as const,
  success: 'border-emerald-500/50 text-emerald-600 dark:text-emerald-400' as const,
}

type AlertVariant = keyof typeof alertVariants

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((
  { className, variant = 'default', ...props },
  ref,
) => {
  const variantClassName = alertVariants[variant] ?? alertVariants.default
  return (
    <div
      ref={ref}
      role="alert"
      className={clsx(
        'relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground',
        variantClassName,
        className,
      )}
      {...props}
    />
  )
})

const AlertTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => {
    return (
      <h5
        ref={ref}
        className={clsx('mb-1 text-sm font-medium leading-none tracking-tight', className)}
        {...props}
      />
    )
  },
)

const AlertDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx('text-sm text-muted-foreground', className)}
        {...props}
      />
    )
  },
)

export { Alert, AlertDescription, AlertTitle }
